import DatePicker from "react-date-picker"

export function toLocalDateParam(d: Date): string {
    const date = new Date(d);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export const CustomDateRangePicker = ({ fromDate, toDate, setFromDate, setToDate, minDate, maxDate }) => {
    return (
        <div className="date-range-picker">
            <div style={{marginRight:"20px"}}>
                <label style={{fontSize:"14px", marginRight:"10px"}}>From:</label>
                <DatePicker 
                    onChange={(e) => {setFromDate(e)}} 
                    value={new Date(fromDate)} 
                    format={"y-MM-dd"} 
                    clearIcon={null}
                    minDate={minDate}
                    maxDate={toDate ? new Date(toDate) : maxDate}
                />
            </div>
            <div>
                <label style={{fontSize:"14px", marginRight:"10px"}}>To:</label>
                <DatePicker 
                    onChange={(e) => {setToDate(e)}} 
                    value={new Date(toDate)} 
                    format={"y-MM-dd"} 
                    clearIcon={null}
                    minDate={fromDate ? new Date(fromDate) : minDate}
                    maxDate={maxDate}
                />
            </div>
        </div>
    )
}

CustomDateRangePicker.defaultProps = {
    minDate: null,
    maxDate: null,
};
